
const addressObjectMap = Object.freeze({
  delivery: "deliveryAddress",
  invoice: "invoiceAddress",
  orderer: "ordererAddress",
});

const validAddressFields = new Set([
  "address1",
  "address2",
  "address3",
  "address4",
  "address5",
  "city",
  "contact",
  "country",
  "customerId",
  "email",
  "reference",
  "telephone",
  "zip",
]);

const handleError = (message) => {
  const isDevLike = process.env.NODE_ENV !== "production";

  if (isDevLike) {
    throw new Error(message);
  } else {
    console.error(message);
    return null;
  }
};

const getBasePath = (editType) => {
  const basePath = addressObjectMap[editType];

  if (!basePath) {
    return handleError(
      `Invalid editType: "${editType}". Valid types: ${Object.keys(addressObjectMap).join(", ")}`
    );
  }

  return basePath;
};

export const getAddressObjectName = (editType) => {
  return getBasePath(editType);
};

export const createAddressFieldPath = (editType, field) => {
  const basePath = getBasePath(editType);

  if (!basePath) {
    return null;
  }

  if (!validAddressFields.has(field)) {
    return handleError(`Invalid address field: "${field}"`);
  }

  return `${basePath}.${field}`;
};
